import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { modalClose } from '@app/store/modal/actions';

function SignatureProgressInformationHeader() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <div className="WindowModal__header">
      <h4 className="WindowModal__header-title">
        <FontAwesomeIcon icon={faUser} /> {t('SignatureProgressInformationHeader-title')}
      </h4>
      <button
        className="WindowModal__header-close-btn"
        type="button"
        onClick={() => dispatch(modalClose())}
      />
    </div>
  );
}

export default SignatureProgressInformationHeader;
